import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from "@angular/core";
import { ClippingStudioMarker } from "app/js/src/domain/clipping-studio/clipping-studio-marker";

@Component({
  selector: "evrideo-clipping-studio-timeline-marker",
  templateUrl: "./clipping-studio-timeline-marker.component.html",
  styleUrls: ["./clipping-studio-timeline-marker.component.scss"],
})
export class ClippingStudioTimelineMarkerComponent implements OnInit, OnChanges {
  @Input() marker: ClippingStudioMarker;
  @Input() leftPercent: number;
  @Input() selected: boolean;
  @Input() isMamSourceMarker = false;
  @Output() markerClick = new EventEmitter<string>();
  @Output() textChange = new EventEmitter<string>();

  /** Local text for input so width reacts while typing; synced from marker when it changes externally. */
  localText = "";

  /** True while the text input is focused; avoids overwriting localText from parent during edit. */
  isFocused = false;

  readonly Math = Math;

  ngOnInit(): void {
    if (this.marker?.text != null) {
      this.localText = this.marker.text;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["marker"] && this.marker?.text !== undefined && !this.isFocused) {
      this.localText = this.marker.text;
    }
  }

  onWrapperClick(event: MouseEvent): void {
    event.stopPropagation();
    this.markerClick.emit(this.marker?.id);
  }

  onTextInput(event: Event): void {
    this.localText = (event.target as HTMLInputElement).value;
  }

  onTextBlur(event: Event): void {
    this.isFocused = false;
    const value = (event.target as HTMLInputElement).value;
    this.textChange.emit(value);
  }

  onTextFocus(): void {
    this.isFocused = true;
  }
}
